import Papa from 'papaparse';

/** @param {{ headers: { label: string, key: string }[], data: Record<string, unknown>[] }} payload */
export function csvStringFromReactCsvPayload(payload) {
  const { headers, data } = payload ?? {};
  if (!headers?.length || !data?.length) {
    return '';
  }
  const fields = headers.map((h) => h.label);
  const rows = data.map((row) =>
    headers.map((h) => (row[h.key] != null ? row[h.key] : ''))
  );
  return Papa.unparse({ fields, data: rows });
}
